import type { CSSProperties } from "react";

// Feeds data-driven values (positions on the day ruler, Gantt bars) to CSS
// custom properties, so blocks.css can place them with `left-(--at)` etc.
export function cssVars(vars: Record<`--${string}`, string>): CSSProperties {
	return vars as CSSProperties;
}
